import * as React from "react";

//components
import { IconButton, MenuHeader } from "../atomics";
import { CSpinner } from "@coreui/react";
import { DrillModeIndicator, OrganizationRow } from "../Organizations";
import { OrganizationResponse } from "../../services/types";
import { OrgSelected } from "../../utils/types";
import AdminsList from "../Admins/AdminsList";
import confirmationDialog from "../toast-dialogs/ConfirmationDialog";
import HandleUIError from "../../utils/HandleUIError";
import { deleteOrganization } from "../../services/OrganizationsServices";
import { Form } from "react-bootstrap";
import { cilPencil, cilTrash } from "@coreui/icons";

interface Props {
  organizations: OrganizationResponse[];
  isLoading: boolean;
  selectedOrg: OrgSelected | null | undefined;
  selectOrg: (org: OrgSelected) => void;
  handleStatus: (id: any, status: any) => void;
  handleDeleteOrganization: (id: any) => void;
  setPreviousAction: (val: boolean) => void;
  previousAction: boolean;
  loading: boolean
  refreshOrganizations: () => Promise<void>;
  currentPage: number,
  defaultOrganization: OrganizationResponse
}

const OrganizationsList: React.FC<Props> = ({
  organizations,
  isLoading,
  selectedOrg,
  selectOrg,
  handleStatus,
  handleDeleteOrganization,
  setPreviousAction,
  previousAction,
  loading,
  refreshOrganizations,
  currentPage,
  defaultOrganization
}) => {

  const [isLoadingDelete, setIsLoadingDelete] = React.useState(false);


  console.log("defaultOrganization", defaultOrganization)
  // async function deleteTemplate(id: any) {
  //   if (id) {
  //     setIsLoadingDelete(true);
  //     try {
  //       await deleteOrganization(id);
  //       await refreshOrganizations();
  //       setIsLoadingDelete(false);
  //     } catch (e) {
  //       setIsLoadingDelete(false);
  //       HandleUIError(e);
  //     }
  //   }
  // }

  // function onPressDelete() {
  //   confirmationDialog({
  //     title: "Are you sure you want to delete this template?",
  //     confirmAction: deleteTemplate,
  //   });
  // }

  const handleTemplateOrg = () => {
    // @ts-ignore
    selectOrg(defaultOrganization)
  }

  return (
    <>
      {!selectedOrg ? (
        <>
          <MenuHeader className="d-flex pt-3 pb-3 justify-content-between">
            <p className="text-color section-width-1 ms-4 d-none d-sm-block justify-content-center">
              S.No
            </p>
            <p className="text-color section-width-2 d-none d-sm-block justify-content-center">
              Name
            </p>
            <p className="text-color section-width-3 d-none d-sm-block justify-content-center">
              Address
            </p>
            <p className="text-color section-width-4 d-none d-sm-block justify-content-center">
              Drill mode
            </p>
            <p className="text-color section-width-4 d-none d-sm-block justify-content-center">
              Status
            </p>
            <p className="text-color  section-width-4  d-none justify-content-center">
              Copy Template
            </p>
            <p className="text-color section-width-4 d-none d-sm-block"></p>
          </MenuHeader>

          <div className={`${defaultOrganization?.is_copy ? "bg-highlight" : ""} d-flex  user-information-container`}>
            <div className="d-flex py-3 justify-content-between  w-100">
              <p className="section-width-1 text-light ms-4">--</p>
              <p className="section-width-2 text-light">{defaultOrganization?.name}</p>
              <p className="section-width-3 text-light ms-2">{defaultOrganization?.address}</p>
              <div className="section-width-4 ms-3">
                <DrillModeIndicator isDrillMode={defaultOrganization?.isDrillMode} />
              </div>
              <p className="section-width text-light  ms-2">
                {defaultOrganization?.active ? (
                  <button className="px-4 btn btn-success text-white small">
                    Active
                  </button>
                ) : (
                  <button className=" px-3  btn btn-danger text-white small">
                    Deactive
                  </button>
                )}
              </p>

              <div className="section-width-4 ms-3 d-none justify-content-center">
                {
                  defaultOrganization?.is_copy && (
                    <>
                      <Form className="organizartion-checkbox">
                        <Form.Check
                          inline
                          checked={true}
                          name="group1"
                          type="checkbox"
                        />
                      </Form>
                    </>
                  )


                }
              </div>

              <div className="section-width-4 d-flex align-items-center m-0 me-3 ">
                <IconButton icon={cilPencil} onClick={handleTemplateOrg} />


                {/* <div>
          {console.log("previousAction", previousAction)}
          {previousAction ? (
            <>
              <IconButton
                icon={cilTrash}
                size="lg"
                className="ms-1"
                // isLoading={isLoading}
                onClick={() => {
                  toast.error("Please confirm the previous action");
                }}
              />
            </>
          ) : (
            <IconButton
              icon={cilTrash}
              size="lg"
              className="ms-1"
              // isLoading={isLoading}
              onClick={() => {
                handleDeleteOrganization(id);
              }}
            />
          )}
        </div> */}

                {/* {
                  !defaultOrganization?.is_copy && (
                    <>
                      <IconButton
                        icon={cilTrash}
                        onClick={onPressDelete}
                        isLoading={isLoadingDelete}
                        className="m-0 ms-3"
                        size="lg"
                      />
                    </>
                  )
                } */}

                {/* < IconButton
          icon={cilTrash}
          size="lg"
          className="ms-1"
          onClick={() => { handleDelete(id) }}
        /> */}

              </div>
            </div>

          </div>
          {!isLoading && organizations ? (
            organizations.map((organization, index: number) => (
              <OrganizationRow
                organization={organization}
                index={index}
                key={organization.id}
                selectOrg={selectOrg}
                handleStatus={handleStatus}
                handleDeleteOrganization={handleDeleteOrganization}
                setPreviousAction={setPreviousAction}
                previousAction={previousAction}
                loading={loading}
                refreshOrganizations={refreshOrganizations}
                currentPage={currentPage}
              />
            ))
          ) : (
            <div className="spinner mt-4">
              <CSpinner variant="grow" />
            </div>
          )}
        </>
      ) : (
        <AdminsList organization={selectedOrg} />
      )}
    </>
  );
};

export default OrganizationsList;
